export const AccountContentNegativeKeyword = {
  parent: 'Account',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Account Shared Content Negative Keyword',
    },
    Status: {
      'bulk-upload-header': 'Status',
    },
    Id: {
      'bulk-upload-header': 'Id',
    },
    ParentId: {
      'bulk-upload-header': 'Parent Id',
    },
    ClientId: {
      'bulk-upload-header': 'Client Id',
    },
    Keyword: {
      'bulk-upload-header': 'Keyword',
    },
    MatchType: {
      'bulk-upload-header': 'Match Type',
    },
    Name: {
      'bulk-upload-header': 'Name',
    },
  },
};
